/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Email_HintInputs */

const en_contact_email_hint = /** @type {(inputs: Contact_Email_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For longer questions or follow-ups.`)
};

const es_contact_email_hint = /** @type {(inputs: Contact_Email_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para preguntas más largas o para dar seguimiento.`)
};

const de_contact_email_hint = /** @type {(inputs: Contact_Email_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für längere Fragen oder Folgeanfragen.`)
};

const zh_contact_email_hint = /** @type {(inputs: Contact_Email_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`适合较复杂的问题或后续沟通。`)
};

const ar_contact_email_hint = /** @type {(inputs: Contact_Email_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`للأسئلة الأطول أو المتابعة.`)
};

const fr_contact_email_hint = /** @type {(inputs: Contact_Email_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour les questions plus détaillées ou les suivis.`)
};

const vi_contact_email_hint = /** @type {(inputs: Contact_Email_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cho câu hỏi dài hơn hoặc liên hệ tiếp theo.`)
};

const sw_contact_email_hint = /** @type {(inputs: Contact_Email_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kwa maswali marefu au ufuatiliaji.`)
};

const th_contact_email_hint = /** @type {(inputs: Contact_Email_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หากมีคำถามหรือติดตามผลเพิ่มเติม`)
};

const bs_contact_email_hint = /** @type {(inputs: Contact_Email_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Za duža pitanja ili nastavak razgovora.`)
};

const ja_contact_email_hint = /** @type {(inputs: Contact_Email_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`長い質問やフォローアップのために。`)
};

const ko_contact_email_hint = /** @type {(inputs: Contact_Email_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`자세한 문의나 추가 문의에 적합합니다.`)
};

const pt_contact_email_hint = /** @type {(inputs: Contact_Email_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para perguntas mais longas ou acompanhamentos.`)
};

const it_contact_email_hint = /** @type {(inputs: Contact_Email_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per domande più articolate o richieste successive.`)
};

const sv_contact_email_hint = /** @type {(inputs: Contact_Email_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`För längre frågor eller uppföljningar.`)
};

const nl_contact_email_hint = /** @type {(inputs: Contact_Email_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voor langere vragen of vervolgvragen.`)
};

const da_contact_email_hint = /** @type {(inputs: Contact_Email_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For længere spørgsmål eller opfølgning.`)
};

const nb_contact_email_hint = /** @type {(inputs: Contact_Email_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For lengre spørsmål eller oppfølging.`)
};

const fi_contact_email_hint = /** @type {(inputs: Contact_Email_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pidemmät kysymykset tai jatkotoimet.`)
};

const pl_contact_email_hint = /** @type {(inputs: Contact_Email_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na dłuższe pytania lub dalszy kontakt.`)
};

const ru_contact_email_hint = /** @type {(inputs: Contact_Email_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для подробных вопросов и дальнейшей переписки.`)
};

const tr_contact_email_hint = /** @type {(inputs: Contact_Email_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daha uzun sorular veya takipler için.`)
};

const hi_contact_email_hint = /** @type {(inputs: Contact_Email_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लंबे प्रश्नों या अनुवर्ती के लिए।`)
};

const id_contact_email_hint = /** @type {(inputs: Contact_Email_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk pertanyaan yang lebih panjang atau tindak lanjut.`)
};

const ms_contact_email_hint = /** @type {(inputs: Contact_Email_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk pertanyaan yang lebih panjang atau susulan.`)
};

const cs_contact_email_hint = /** @type {(inputs: Contact_Email_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro delší otázky nebo doplňující dotazy.`)
};

const el_contact_email_hint = /** @type {(inputs: Contact_Email_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Για πιο αναλυτικές ερωτήσεις ή για συνέχεια της επικοινωνίας.`)
};

const he_contact_email_hint = /** @type {(inputs: Contact_Email_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`לשאלות ארוכות יותר או מעקב.`)
};

const af_contact_email_hint = /** @type {(inputs: Contact_Email_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vir langer vrae of opvolgings.`)
};

const hu_contact_email_hint = /** @type {(inputs: Contact_Email_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hosszabb kérdésekért vagy nyomon követésért.`)
};

/**
* | output |
* | --- |
* | "For longer questions or follow-ups." |
*
* @param {Contact_Email_HintInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const contact_email_hint = /** @type {((inputs?: Contact_Email_HintInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Email_HintInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_contact_email_hint(inputs)
	if (locale === "de") return de_contact_email_hint(inputs)
	if (locale === "zh") return zh_contact_email_hint(inputs)
	if (locale === "ar") return ar_contact_email_hint(inputs)
	if (locale === "fr") return fr_contact_email_hint(inputs)
	if (locale === "vi") return vi_contact_email_hint(inputs)
	if (locale === "sw") return sw_contact_email_hint(inputs)
	if (locale === "th") return th_contact_email_hint(inputs)
	if (locale === "bs") return bs_contact_email_hint(inputs)
	if (locale === "ja") return ja_contact_email_hint(inputs)
	if (locale === "ko") return ko_contact_email_hint(inputs)
	if (locale === "pt") return pt_contact_email_hint(inputs)
	if (locale === "it") return it_contact_email_hint(inputs)
	if (locale === "sv") return sv_contact_email_hint(inputs)
	if (locale === "nl") return nl_contact_email_hint(inputs)
	if (locale === "da") return da_contact_email_hint(inputs)
	if (locale === "nb") return nb_contact_email_hint(inputs)
	if (locale === "fi") return fi_contact_email_hint(inputs)
	if (locale === "pl") return pl_contact_email_hint(inputs)
	if (locale === "ru") return ru_contact_email_hint(inputs)
	if (locale === "tr") return tr_contact_email_hint(inputs)
	if (locale === "hi") return hi_contact_email_hint(inputs)
	if (locale === "id") return id_contact_email_hint(inputs)
	if (locale === "ms") return ms_contact_email_hint(inputs)
	if (locale === "cs") return cs_contact_email_hint(inputs)
	if (locale === "el") return el_contact_email_hint(inputs)
	if (locale === "he") return he_contact_email_hint(inputs)
	if (locale === "af") return af_contact_email_hint(inputs)
	if (locale === "hu") return hu_contact_email_hint(inputs)
	return en_contact_email_hint(inputs)
});